module.exports = __webpack_public_path__ + "img/pic_empty_people@2x.f35b5312.png";